<template>
    <div class="flex flex-wrap gap-4">
        <input type="hidden" :name="name" value="" />

        <label v-for="(option, optionIndex) in options" :key="optionIndex" class="flex items-center">
            <input type="checkbox" :name="name" :value="option.value" v-model="selectedValue" />
            <span v-if="option.color" :style="{ background: option.color }" class="ml-2 w-4 h-4 rounded-full"></span>
            <span class="ml-1">{{ option.label }}</span>
        </label>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'

export default {
    props: ['field', 'value'],
    data() {
        return {
            name: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, '')
                .substr(0, 5),
            selectedValue: this.value || [],
        }
    },
    watch: {
        selectedValue(val) {
            this.$emit('input', val)
        },
    },
    computed: {
        options() {
            if (this.field.reference) return this.field.reference.atributos_extras.options
            if (this.field.atributos_extras && this.field.atributos_extras.options)
                return this.field.atributos_extras.options
            return this.field.options || []
        },

        placeholder() {
            return Form.placeholder(this.field)
        },
    },
}
</script>
